import React from 'react';
import { ComponentMaintenanceData } from '../../../../../Helpers/maintenanceCostUtils';
import { uploadReplacementAttachment } from '../../utils/maintenanceAttachmentUtils';
import { CostConfigurationModal, CostConfigurationData } from './shared';
import { CostUnit } from '../../../../Förvaltning/TemplatesEditor/types';

interface ReplacementCostModalProps {
    componentKey: string;
    componentName: string;
    buildingKey: string;
    componentData: ComponentMaintenanceData;
    calculatedCost: number;
    quantity: number | null;
    costExplanation: string;
    componentType: string;
    componentTypeName: string;
    templateCost: number;
    templateCostUnit: CostUnit;
    onSave: (settings: CostConfigurationData) => void;
    onClose: () => void;
    onOpenEditTemplateCost: () => void;
}

/**
 * Modal for configuring replacement cost settings.
 */
export const ReplacementCostModal: React.FC<ReplacementCostModalProps> = ({
    componentKey,
    componentName,
    buildingKey,
    componentData,
    calculatedCost,
    quantity,
    costExplanation,
    templateCost,
    templateCostUnit,
    onSave,
    onClose,
    onOpenEditTemplateCost
}) => {
    const handleUpload = (file: File, userId: string) => {
        return uploadReplacementAttachment(
            buildingKey,
            componentKey,
            file,
            userId
        );
    };

    return (
        <CostConfigurationModal
            title={`Ersättningskostnad - ${componentName}`}
            costExplanation={costExplanation}
            calculatedCost={calculatedCost}
            templateUnitPrice={templateCost}
            costUnit={templateCostUnit}
            quantity={quantity}
            attachmentEntityType="maintenanceReplacementAttachment"
            initialCostSource={componentData.replacementCostSource || 'template'}
            initialCustomCost={componentData.replacementCostSource === 'custom' ? componentData.replacementCost : undefined}
            initialCustomUnitPrice={componentData.replacementCostSource === 'customRate' ? componentData.replacementCustomUnitPrice : undefined}
            initialComment={componentData.replacementCostComment}
            initialAttachments={componentData.replacementAttachments}
            initialInvestmentPercentage={componentData.replacementInvestmentPercentage}
            uploadAttachment={handleUpload}
            onSave={onSave}
            onClose={onClose}
            onOpenEditTemplateCost={onOpenEditTemplateCost}
        />
    );
};
